import api from "../api/api";
import useUrlQuery from "../hooks/useUrlQuery";
import { useMutation, useQuery } from "@tanstack/react-query";

export const useStatusQuery = () => {
  const { get } = useUrlQuery();
  const proposal_id = get("proposal_id");

  const { data, isLoading, isSuccess } = useQuery({
    queryKey: ["status", proposal_id],

    queryFn: async () => {
      const res = await api.post("api/GetPolicyDetails", {
        PROPOSAL_ID: proposal_id,
      });
      return res.data;
    },

    enabled: !!proposal_id,
    retry: false,
  });

  return {
    status: data?.POLICY_DATA?.[0],
    isLoading,
    isSuccess,
  };
};

export const useGetDocument = () => {
  const { isSuccess, status } = useStatusQuery();
  const { get } = useUrlQuery();
  const proposal_id = get("proposal_id");

  const { data, isLoading, refetch } = useQuery({
    queryKey: ["document", proposal_id],

    queryFn: async () => {
      const res = await api.post("api/GenerateDocument", {
        PROPOSAL_ID: proposal_id,
      });
      return res.data;
    },

    enabled: isSuccess && !status?.POLICY_DOC,
    retry: false,
  });

  return {
    data: data?.response?.POLICY_DOC,
    isLoading,
    refetch,
  };
};

export const useRetryDocument = () => {
  return useMutation({
    mutationFn: async (payload) => {
      const res = await api.post("/api/PolicyStatusResponse", {
        POLICY_NUMBER: payload?.POLICY_NUMBER,
      });

      return res?.data?.response?.POLICY_DOC;
    },
  });
};
